/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2010 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class servicedate extends IceEntity {
  service_date_key: string = "";
  date_required: any = NaN;
  end_date_required: any = NaN;
  datetime_qualifier: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
    return "SERVICE_DATE";
  }
}
